"use client";
import { useTranslations } from "next-intl";
import Link from "next/link";

// Error components must be Client Components

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const t = useTranslations("Utils");
  console.error(error);

  return (
    <div
      data-testid="error"
      className="flex items-center h-full p-16 bg-white rounded-2xl"
    >
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <div className="max-w-md text-center">
          <h2 className="mb-8 font-extrabold text-9xl text-indigo-500">
            <span className="sr-only">{t("error")}</span>
            {t("oops")}
          </h2>
          <p className="text-2xl font-semibold md:text-3xl text-black">
            {t("anerroroccurred")}
          </p>
          <p className="mt-4 mb-8 text-gray-500">
            {t.rich("dontworrywithcontactlink", {
              button: (chunks) => (
                <Link
                  href={"/contact"}
                  className="text-black underline font-semibold"
                >
                  {chunks}
                </Link>
              ),
            })}
          </p>

          <button
            onClick={() => reset()}
            className="mt-4 px-8 py-2 rounded-md bg-indigo-600 hover:bg-indigo-500 text-white font-semibold transition-colors duration-200 ease-in-out"
          >
            {t("tryagain")}
          </button>
        </div>
      </div>
    </div>
  );
}
